import MfaForm from '../../users/components/MfaForm.tsx';
import AuthPage from '../components/AuthPage.tsx';
import { useTranslation } from 'react-i18next';
import Button from '../../core/components/Button.tsx';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useApplicationContext } from '../../core/contexts/ApplicationContext.tsx';
import classnames from '../../core/utils/classnames.tsx';
import { Link } from 'react-router';
import { SETUP_MFA_RECOVERY_PATH } from '../constants.ts';
import { safeInternalUrl, url } from '../../core/utils/link.ts';

const SetupMfaPage = () => {
    const { t } = useTranslation('user');

    const [searchParams] = useSearchParams();
    const nextLocation = safeInternalUrl(searchParams.get('next'));

    const { user, refetchUser } = useApplicationContext();

    const handleDevicesChange = async () => {
        await refetchUser();
    };

    const isMfaRequired = user?.customer?.mfaConfig?.isRequired;
    const hasDevice = user?.hasMfaDevice;

    return (
        <AuthPage>
            <AuthPage.Content>
                <AuthPage.Card className="w-[40rem]">
                    <AuthPage.Title>{t('setupMfa.title')}</AuthPage.Title>

                    <p className="text-content-strong">
                        {isMfaRequired ? t('setupMfa.requiredDescription') : t('setupMfa.recommendedDescription')}
                    </p>

                    <MfaForm hideStatic onDevicesChange={handleDevicesChange} />

                    <div className="flex justify-end gap-2">
                        {!isMfaRequired && (
                            <Button
                                variant="ghost"
                                className="hover:bg-surface-strong hover:text-content-strong"
                                asChild
                            >
                                <a href={nextLocation}>{t('setupMfa.continueWithoutMfaButton')}</a>
                            </Button>
                        )}

                        <Button
                            variant="primary"
                            asChild
                            className={classnames(
                                'hover:!bg-surface-brand-strong-hover focus:!bg-surface-brand-strong-focus active:!bg-surface-brand-strong-active',
                                !hasDevice &&
                                    'hover:!bg-surface-brand-strong-hover focus:!bg-surface-brand-strong-hover active:!bg-surface-brand-strong-hover'
                            )}
                            disabled={!hasDevice}
                            onClick={(e) => {
                                if (!hasDevice) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.currentTarget.blur();
                                }
                            }}
                        >
                            <Link to={url(SETUP_MFA_RECOVERY_PATH, undefined, { search: { next: nextLocation } })}>
                                {t('setupMfa.continueButton')}
                            </Link>
                        </Button>
                    </div>
                </AuthPage.Card>
            </AuthPage.Content>
        </AuthPage>
    );
};

export default SetupMfaPage;
